/**
 * Entity Size Registry for Helix 2000
 * Defines the tile dimensions for different entity types in the editor
 * 
 * Sizes are in tiles (not pixels)
 * width: number of tiles wide
 * height: number of tiles tall
 */

export interface EntitySize {
  width: number;  // in tiles
  height: number; // in tiles
  description: string;
}

/**
 * Entity size registry - defines how many tiles each entity occupies
 */
export const ENTITY_SIZES: Record<string, EntitySize> = {
  // Mobs
  'pig': { width: 2, height: 2, description: 'Wild Pig' },
  'training_dummy': { width: 1, height: 2, description: 'Training Dummy' },
  'snail': { width: 1, height: 1, description: 'Blue Snail' },
  'mushroom': { width: 2, height: 2, description: 'Orange Mushroom' },
  'slime': { width: 1, height: 1, description: 'Green Slime' },
  
  // NPCs
  'tomas': { width: 1, height: 2, description: 'Tomas the Researcher' },
  'sophia': { width: 1, height: 2, description: 'Sophia the Explorer' },
  'grant': { width: 1, height: 2, description: 'Grant the Veteran' },
  
  // Special objects
  'teleporter': { width: 2, height: 4, description: 'Teleporter (2x4)' },
  'chest': { width: 1, height: 1, description: 'Treasure Chest' },
  'spawn_point': { width: 1, height: 1, description: 'Player Spawn Point' },
};

/**
 * Get the size for an entity type
 * Returns default 1x1 if not found
 */
export function getEntitySize(entityType: string): EntitySize {
  return ENTITY_SIZES[entityType] || { width: 1, height: 1, description: 'Unknown Entity' };
}

/**
 * Check if an entity type has a defined size
 */
export function hasEntitySize(entityType: string): boolean {
  return entityType in ENTITY_SIZES;
}

/**
 * Get all available entity types with their sizes
 */
export function getAllEntitySizes(): Record<string, EntitySize> {
  return { ...ENTITY_SIZES };
}
